import { QueryClient } from "@tanstack/react-query"

/**
 * Shared TanStack Query client for the tenant-app.
 *
 * Defaults chosen for an authenticated SaaS shell:
 * - `staleTime: 30s` — cached data is treated as fresh for 30s before a
 *   background refetch triggers on next mount. Cuts BE load on tab-switch,
 *   still keeps data reasonably live.
 * - `gcTime: 5min` (was cacheTime pre-v5) — unmounted queries stay in cache
 *   for 5min so quick back-and-forth navigation doesn't refetch.
 * - `refetchOnWindowFocus: false` — annoying in a data-entry app; users
 *   don't expect their form state or a listing to jitter on tab-back.
 *   Explicit invalidation (post-mutation, socket event) refreshes what
 *   matters.
 * - `retry: 1` — one silent retry on network blips. More than that and the
 *   user waits too long for the error state.
 *
 * Global mutation defaults are conservative — retry disabled by default
 * because mutations should never be silently retried without the caller
 * opting in (POST twice = duplicate journal entry, etc.).
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
})
